import React from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AlertUI = ({ type, text }) => {

  const getIcon = () => {
    if (type === "success") return <i className="ri-checkbox-circle-fill fs-5"></i>;
    if (type === "error") return <i className="ri-close-circle-fill fs-5"></i>;
    if (type === "warning") return <i className="ri-error-warning-fill fs-5"></i>;
    return <i className="ri-information-fill fs-5"></i>;
  };

  const getClass = () => {
    if (type === "success") return "alert alert-success";
    if (type === "error") return "alert alert-danger";
    if (type === "warning") return "alert alert-warning";
    return "alert alert-primary";
  };

  return (
    <div className={`${getClass()} d-flex align-items-center gap-2 mb-0`} style={{width:'95%'}}>
      {getIcon()}
      <div className="w-100">{text}</div>
    </div>
  );
};

// Main function
const ToastAlert = ({ type = "success", text = "" }) => {
  toast(<AlertUI type={type} text={text} />, {
    position:"top-center",
    autoClose: 3000,
  });
};

// Container (add once in App)
export const AlertContainer = () => <ToastContainer />;

export default ToastAlert;

//Example call Alert
// Alert({ type: "success", text: "Login successful!" });
// Alert({ type: "error", text: "Something went wrong!" });
// Alert({ type: "warning", text: "Check your input!" });